import React, { useContext } from 'react';
import { FocusBaseContext } from '../../contexts';

const TotalRespondents = () => {
  const { currentSummary } = useContext(FocusBaseContext);
  return (
    <div className="page-section summary-swipe">
      <div className="summary-swipe_row">
        <div className="summary-swipe_col" />
        <div className="summary-swipe_col">
          <div className="summary-swipe_icon">
            <svg className="icon -summary-users"><use xlinkHref="#svg_summary-users" /></svg>
          </div>
          <div className="summary-swipe_title">
            { currentSummary.report.total_respondents }
          </div>
          <div className="summary-swipe_description">Total Respondents</div>
        </div>
        <div className="summary-swipe_col" />
      </div>
    </div>
  );
};

export default TotalRespondents;
